import { forwardRef } from "react";
import type { LabelHTMLAttributes } from "react";
import { cn } from "../lib/cn";

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  /** Marca visual + texto para leitor de tela. */
  required?: boolean;
  /** Label de campo desabilitado fica esmaecido junto. */
  disabled?: boolean;
}

/**
 * Label SEMPRE visível acima do controle.
 * Placeholder fazendo as vezes de label é anti-padrão (seção 12).
 */
export const Label = forwardRef<HTMLLabelElement, LabelProps>(function Label(
  { className, required = false, disabled = false, children, ...props },
  ref,
) {
  return (
    <label
      ref={ref}
      className={cn(
        "text-xs font-medium text-muted-foreground select-none",
        disabled && "opacity-50",
        className,
      )}
      {...props}
    >
      {children}
      {required ? (
        <>
          <span aria-hidden="true" className="ml-0.5 text-danger">
            *
          </span>
          <span className="sr-only"> (obrigatório)</span>
        </>
      ) : null}
    </label>
  );
});
